module.exports = __webpack_public_path__ + "static/img/title.b3daa317.png";